<template>
  <Label
    :class="['FieldLabel', { 'is-disabled': disabled }]"
    v-bind="forwardedProps"
  >
    <slot />
    <span v-if="required && !hideAsterisk" class="FieldLabel-required">*</span>
  </Label>
</template>

<script setup lang="ts">
import { Label, useForwardProps, type LabelProps } from 'reka-ui';
import { computed } from 'vue';

export interface FieldLabelProps extends LabelProps {
  required?: boolean;
  hideAsterisk?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<FieldLabelProps>(), {
  required: false,
  hideAsterisk: false,
  disabled: false,
});

const forwardedProps = useForwardProps(computed(() => ({
  for: props.for,
})));
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .FieldLabel {
    display: flex;
    align-items: center;
    // TODO CVO-18267: Replace fallback values with generic field label tokens once updated in Figma
    color: var(--field-label-color, #{vars.$atoms-input-enabled-label-color});
    @include text.text('sm', vars.$typography-weight-strong);
    white-space: nowrap;

    &.is-disabled {
      pointer-events: none;
    }

    &-required {
      // TODO CVO-18267: Replace fallback values with generic field label tokens once updated in Figma
      color: var(--field-label-required-color, #{vars.$atoms-input-mandatory-color});
      margin-inline-start: vars.$dimensions-d-1;
    }
  }
}
</style>
